import styled, { css, DefaultTheme, keyframes } from "styled-components";

export type SkeletonType = "text";

const shimmerAnimation = keyframes`
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: -100% 0;
    }
`;

export const Wrap = styled.div<{ type: SkeletonType }>`
  border-radius: 0.4rem;

  ${({ theme, type }) => cssSkeletonType(theme, type)}

  animation: ${shimmerAnimation} 1.5s infinite;
`;

function cssSkeletonType(theme: DefaultTheme, type: SkeletonType) {
  switch (type) {
    case "text":
      return css`
        background-image: linear-gradient(
          90deg,
          ${theme.color.background.dark},
          #f0f0f0,
          ${theme.color.background.dark}
        );
        background-size: 200% 100%;
        background-position: 100% 0;
        width: 100%;
        height: ${theme.typography.body1.regular.lineHeight};
      `;
    default:
      return;
  }
}
